import {useEffect, useRef} from 'react';
import styles from './description-list.module.scss';

export const DescriptionsList = ({data, columns = 3, className = ''}) => {
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
    }
  });

  return (
    <div ref={listRef} className={`${styles.list} ${className}`}>
      {data
        .filter(({value}) => value || value === 0)
        .map(({label, value}) => (
          <div
            key={label}
            className={styles.item}
            title={label}
            role="listItem"
          >
            <span className={styles.label}>{label}:</span>
            <span className={styles.value}>{value}</span>
          </div>
        ))}
    </div>
  );
};
